






























import { Vue, Component } from 'vue-property-decorator';
import { SwipeItem, Swipe, ImagePreview, Button } from 'vant';
import { getDetail } from '../api';
import XGPlayer from '@/components/XGplayer.vue';

Vue.use(SwipeItem).use(Button);

@Component({
  components: {
    XGPlayer,
  },
})
export default class Detail extends Vue {
  data: any = {};

  async created() {
    const { id } = this.$route.query as any;
    const ret = await getDetail(id);
    this.data = ret.data;
  }
  onImageClick(imgUrl: string, index: number) {
    ImagePreview({
      startPosition: index,
      images: this.data.cover,
      closeable: true,
    });
  }
  onNavBack() {
    if (history.length > 1) {
      this.$router.back();
    } else {
      location.href = `${location.origin}${process.env.VUE_APP_PUBLIC_PATH}2020-civilization-movement-in-chongqing`;
    }
  }
}
